// Dispara os eventos 'AddPaymentInfo'
function dispatchPaymentInfo() {
  dispatchPixelEvent('facebook', 'AddPaymentInfo');
  dispatchPixelEvent('tiktok', 'AddPaymentInfo');
  dispatchPixelEvent('analytics', 'add_payment_info');
}

// Dispara um evento do pixel
function dispatchPixelEvent(service, eventName) {
  let pxEventDispatched = false;
  if (!previewMode) {
    // Nome do evento pro cookie de dedup — separado do nome usado nas chamadas de API
    // (que variam por serviço: 'AddPaymentInfo' no Facebook/TikTok, 'add_payment_info'
    // no Analytics). Minúsculo, igual ao padrão de 'checkout'/'purchase'/'card_refused'
    // usado no restante do checkout.
    const cookieEventName = 'payment_info';
    // Verifica se o pixel já foi disparado
    if (!verifyPixelEvent(service, cookieEventName, cartId)) {
      // AddPaymentInfo
      if ((eventName === 'AddPaymentInfo' || eventName === 'add_payment_info') && validateAddPaymentInfo()) {
        // Facebook
        if (service === 'facebook' && typeof fbq === 'function') {
          const pixels = $('.co-payment').data('fb-pixels');
          if (pixels && Object.keys(pixels).length > 0) {
            // Um único eventID pra todos os pixels desse disparo — precisa bater com o
            // event_id usado no disparo assíncrono (LpqvTracking.dispatch) pro dedup do
            // Meta funcionar (client x CAPI). Reuso do mesmo ID entre pixels diferentes
            // não causa colisão: a dedup do Meta é escopada por pixel_id.
            const pxEventId =
              'EV-' + Date.now().toString(36) + Math.random().toString(36).slice(2).toUpperCase();
            const firstPixel = pixels[Object.keys(pixels)[0]];
            Object.keys(pixels).forEach((i) => {
              const px = pixels[i];
              fbq('trackSingle', '' + px.id + '', 'AddPaymentInfo', px.infos, { eventID: pxEventId });
            });
            if (window.LpqvTracking) {
              let name = $('#co-name').val();
              let firstname;
              let lastname;
              if (name && name.trim() != '') {
                const nameArr = name.trim().toLowerCase().split(' ');
                firstname = nameArr[0];
                lastname = nameArr[nameArr.length - 1];
              }
              window.LpqvTracking.dispatch('AddPaymentInfo', {
                eventId: pxEventId,
                referenceType: 'cart',
                referenceId: cartId,
                commerce: firstPixel.infos,
                userData: {
                  firstname: firstname,
                  lastname: lastname,
                  email: $('#co-email').val() || undefined,
                  phone: $('#co-phone').val() || undefined,
                  city: $('#co-city').val() || undefined,
                  state: $('#co-state').val() || undefined,
                  zip_code: $('#co-zipcode').val() || undefined,
                  fbclid: firstPixel.fbclid,
                },
              });
            }
          }
          pxEventDispatched = true;
        }
        // Tiktok
        else if (service === 'tiktok' && typeof ttq === 'object') {
          ttq.track('AddPaymentInfo');
          pxEventDispatched = true;
        }
        // Google Analytics
        else if (service === 'analytics') {
          const pixelInfos = $('.co-payment').data('ana-pixels');
          const paymentMehod = getOption('payment_title')
            ? getOption('payment_title')
            : $('.payment-item input[name="payment_method"]:checked').data('title');
          if (pixelInfos && Object.keys(pixelInfos).length > 0) {
            if (typeof gtag !== 'undefined') {
              gtag('event', 'add_payment_info', {
                currency: pixelInfos.currency,
                value: pixelInfos.value,
                payment_type: paymentMehod,
                items: pixelInfos.items,
              });
            } else if (typeof dataLayer !== 'undefined') {
              dataLayer.push({ ecommerce: null });
              dataLayer.push({
                event: 'add_payment_info',
                ecommerce: {
                  currency: pixelInfos.currency,
                  value: pixelInfos.value,
                  payment_type: paymentMehod,
                  items: pixelInfos.items,
                },
              });
            }
            pxEventDispatched = true;
          }
        }
      }
      if (pxEventDispatched) {
        storePixelEvent(service, cookieEventName, cartId);
        console.log(`Pixel (${service}): '${eventName}' disparado.`);
      }
    } else {
      console.log(`Pixel (${service}): '${eventName}' já foi disparado.`);
    }
  }
}

// Verifica se um evento já foi disparado para o mesmo checkout (carrinho)
function verifyPixelEvent(service, event, identification) {
  const cookieKey = `${service}-${event}-${identification}`;
  return getCookie(cookieKey);
}
/* function dispatchedPixelEvent(service, eventName) {
  let pxEventsList = localStorage.getItem('lpqv_px_events');
  if (pxEventsList) {
    pxEventsList = JSON.parse(pxEventsList);
    return pxEventsList.some(
      (item) => item.service === service && item.event === eventName && item.cart_token === cartToken,
    );
  }
  return false;
} */

// Salva um evento já disparado
function storePixelEvent(service, event, identification) {
  const cookieKey = `${service}-${event}-${identification}`;
  const cookieVal = new Date().getTime();
  setCookie(cookieKey, cookieVal, 7);
}
/* function savePixelEvent(service, eventName) {
  let pxEventsList = localStorage.getItem('lpqv_px_events');
  if (!pxEventsList) {
    pxEventsList = [];
  } else {
    pxEventsList = JSON.parse(pxEventsList);
  }
  const pxEventObj = {
    service: service,
    event: eventName,
    cart_token: cartToken,
  };
  pxEventsList.push(pxEventObj);
  localStorage.setItem('lpqv_px_events', JSON.stringify(pxEventsList));
} */

// Verifica se já é possível disparar o evento 'AddPaymentInfo' (Só dispara se já tiver preenchido o e-mail e selecioado uma forma de pagamento)
function validateAddPaymentInfo() {
  let isValid = false;
  if (!checkoutStepsEnable) {
    isValid =
      $('#co-email').val() != '' &&
      ($('.payment-item input[name="payment_method"]:checked').val() != '' ||
        $('.co-payment-tabs-input[name="payment_method"]:checked').val() != '');
  } else {
    isValid = $('#co-email').val() != '';
  }
  return isValid;
}

